import React, { Component } from 'react';
import { Link } from 'react-router';
import MobileNav from './MobileNav';

class Nav extends Component {

  render() {

    let navClasses = "nav page-container-responsive space-top-4 space-top-sm-2 space-4 space-sm-2";

    if (this.props.homepage) {
      navClasses = "nav page-container-responsive space-top-4 space-top-sm-2 space-5";
    }

    return (
      <div className="Nav">
        <div className={navClasses}>
          <Link to="/" className="tinydoorman-logo pull-left">Tiny Doorman</Link>

          <ul className="pull-right nav-list list-unstyled hide-sm">
            <li><Link to="/faq" className="nav-item" activeClassName="active">Faq</Link></li>
            <li><Link to="/building-managers" className="nav-item" activeClassName="active">Building Managers</Link></li>
            <li><Link to="/get-the-app" className="header-btn">Get the app</Link></li>
          </ul>

          <MobileNav />

        </div>
      </div>
    );
  }
}

export default Nav;



/** WEBPACK FOOTER **
 ** ./src/components/Nav.js
 **/